import React, { useEffect } from 'react';

import styles from './styles';
import { withStyles } from '@material-ui/core';

import { Alert } from '@cobliteam/alert';

import { useGetMediaView } from '@cobliteam/hooks/src/useCamera/useCameraMedia';

import { Dialog, Divider } from '@cobliteam/base-components';

import MediaDialogPlayer from './components/MediaDialogBody/components/MediaDialogPlayer/MediaDialogPlayer';
import MediaDialogBody from './components/MediaDialogBody/MediaDialogBody';
import MediaDialogDriverInfo from './components/MediaDialogDriverInfo/MediaDialogDriverInfo';
import MediaDialogFooter from './components/MediaDialogFooter/MediaDialogFooter';
import MediaDialogHeader from './components/MediaDialogHeader/MediaDialogHeader';

import useMediaStore from '../../store/zustand/useMediaStore';

export interface MediaDialogProps {
  origin?: string;
  onClose: () => void;
  onNextMediaClick?: () => void;
  onPreviousMediaClick?: () => void;
  hasNextMedia?: boolean;
  hasPreviousMedia?: boolean;
  isNavigationButtonsDisabled?: boolean;
  isFetchingMediaRows?: boolean;
}
const BorderlessDialog = withStyles(() => ({
  paper: {
    border: 'unset',
  },
}))(Dialog);

export const MediaDialog: React.FC<MediaDialogProps> = React.memo(
  ({
    origin,
    onClose,
    onNextMediaClick,
    onPreviousMediaClick,
    isNavigationButtonsDisabled,
    hasPreviousMedia,
    hasNextMedia,
    isFetchingMediaRows,
  }) => {
    const mediaViewId = useMediaStore((state) => state.mediaViewId);

    const {
      data: mediaView,
      isError,
      isFetched,
    } = useGetMediaView(mediaViewId);

    const mediaUrl = mediaView?.mediaUrl;

    useEffect(() => {
      if (isError || (isFetched && !mediaUrl)) {
        Alert.error('Erro ao obter dados do vídeo.');
        onClose();
      }
    }, [mediaUrl, isError, isFetched]);

    return (
      <BorderlessDialog
        open={!!mediaViewId}
        overflowY='auto'
        onClose={onClose}
        maxWidth='lg'
        className={styles.modal}
      >
        <MediaDialogHeader
          onClose={onClose}
          isFetchingMediaRows={isFetchingMediaRows}
        />
        <Divider />
        <MediaDialogDriverInfo isFetchingMediaRows={isFetchingMediaRows} />
        <MediaDialogPlayer
          origin={origin}
          isFetchingMediaRows={isFetchingMediaRows}
        />
        <MediaDialogBody isFetchingMediaRows={isFetchingMediaRows} />
        <Divider />
        <MediaDialogFooter
          onNextMediaClick={onNextMediaClick}
          onPreviousMediaClick={onPreviousMediaClick}
          hasPreviousMedia={hasPreviousMedia}
          hasNextMedia={hasNextMedia}
          isNavigationButtonsDisabled={isNavigationButtonsDisabled}
          isFetchingMediaRows={isFetchingMediaRows}
        />
      </BorderlessDialog>
    );
  }
);

export default MediaDialog;
